<template>
  <v-card>
    <v-card-title>Cards</v-card-title>
    <div>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="8"
          >
            <v-text-field
              v-model="search"
              :append-icon="icons.mdiMagnify"
              label="Search"
              single-line
              hide-details
              dense
              outlined
              @keyup="searchData"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <div class="text-center">
              <v-btn
                color="primary"
                block
                @click="ExportData"
              >
                <v-icon>{{ icons.mdiDownload }}</v-icon> Export
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Table -->
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :options.sync="options"
        :server-items-length="totalItems"
        class="table-kitchen-sink"
      >
        <!-- Image -->
        <template v-slot:item.image_url="{ item }">
          <v-img
            contain
            height="64"
            max-width="64"
            :src="item.image_url"
          ></v-img>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="deleteItemConfirmation(item)"
              >
                {{ icons.mdiDeleteOutline }}
              </v-icon>
            </template>
            <span>Delete</span>
          </v-tooltip>

          <!-- Delete dialog -->
          <c-dialog
            v-model="isDeleteItemDialogVisible"
            @onConfirm="deleteItem"
          >
            Are you sure want to delete '{{ selectedItem.name }}'?
          </c-dialog>
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>

<script>
import {
	mdiPlus,
	mdiMagnify,
	mdiPencilOutline,
	mdiDeleteOutline,
	mdiDownload,
	mdiDelete,
} from '@mdi/js'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
	components: {},
	data() {
		return {
			formType: 'addItem',
			selectedItem: {},
			isDeleteItemDialogVisible: false,
			isFormVisible: false,
			headers: [
				{ text: 'CARD NUMBER', value: 'card_number' },
				{ text: 'MEMBER FIRST NAME', value: 'user.first_name' },
				{ text: 'MEMBER LAST NAME', value: 'user.last_name' },
				{ text: 'MEMBER MOBILE NUMBER', value: 'user.mobile_number' },

				{
					text: 'ACTIONS',
					value: 'actions',
					sortable: false,
					width: '150px',
				},
			],
			icons: {
				mdiPlus,
				mdiMagnify,
				mdiPencilOutline,
				mdiDeleteOutline,
				mdiDownload,
				mdiDelete,
			},

		}
	},
	computed: {
		...mapGetters('card', ['items', 'totalItems']),
		options: {
			get() {
				return this.$store.getters['card/options']
			},
			set(value) {
				this.$store.commit('card/SET_OPTIONS', value)
			},
		},
		search: {
			get() {
				return this.$store.getters['card/search']
			},
			set(value) {
				this.$store.commit('card/SET_SEARCH', value)
			},
		},

	},
	watch: {
		options() {
			this.datatable()
		},
	},
	methods: {
		searchData: _.debounce(function fn() {
			this.datatable()
		}, 400),
		ExportData: _.debounce(function fn() {
			this.exportdata()
		}, 400),
		datatable() {
			this.$store.dispatch('card/datatable')
		},
		exportdata() {
			this.$store.dispatch('card/exportData')
		},
		deleteItemConfirmation(item) {
			this.selectedItem = JSON.parse(JSON.stringify(item))
			this.isDeleteItemDialogVisible = true
		},
		deleteItem() {
			this.$store
				.dispatch('card/destroy', this.selectedItem.card_number)
				.then(response => {
					this.$store.commit('app/SET_SNACKBAR_SUCCESS', response.data?.message)
					this.datatable()
				})
				.catch(error => {
					this.$store.commit('app/SET_SNACKBAR_ERROR', error.response.data?.message)
				})
		},
	},
}
</script>
